import gifPausalo from '../../../images/pausar.gif';
import gifGrabalo from '../../../images/grabar.gif';
import gifRebobinalo from '../../../images/rebobinar.gif';

import gif1Bkg from '../../../images/gif1Bkg.png';
import gif2Bkg from '../../../images/gif2Bkg.png';
import gif3Bkg from '../../../images/gif3Bkg.png';
import { GifComponent } from "../../pages/home/GifComponent";
import pausalo from '../../../videos/pausar.mp4';
import grabalo from '../../../videos/grabar.mp4';
import rebobinalo from '../../../videos/rebobinar.mp4';

const FuncionesExperienciaUnica = () =>(
    <>
        <section className="experienciaUnica">
            <div className="container">
                <h2 className="titles">Funciones que hacen a la <br />
                    <span>experiencia única</span>
                </h2>  
                <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                        
                        <GifComponent
                            sourceGif={gifPausalo}
                            sourceBkg={gif1Bkg}
                            className={"pausalo"}
                            mp4={pausalo}
                            title={"Páusalo"}
                            copy={"¿Suena el timbre o el teléfono? Pon pausa y responde tranquilo."}
                        />

                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                        <GifComponent
                            sourceGif={gifGrabalo}
                            sourceBkg={gif2Bkg}
                            className={"grabalo"}
                            mp4={grabalo}
                            title={"Grábalo"}
                            copy={"Graba tus contenidos para verlos en otro momento."}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                        <GifComponent
                            sourceGif={gifRebobinalo}
                            sourceBkg={gif3Bkg}
                            className={"rebobinalo"}
                            mp4={rebobinalo}
                            title={"Rebobínalo"}
                            copy={"¿Te perdiste de algo? Retrocede en el tiempo y vuelve a ver qué pasó."}
                        />
                    </div>
                </div>
            </div>
        </section>
    </>
)

export default FuncionesExperienciaUnica;